import React from 'react'

// "Why choose us" grid, shared by every service hub. The reasons come from
// data/service-hub-content.js as [{ icon, title, desc }].
//
// theme "dark": glass cards on a slate band (aircon pages).
// theme "light": bordered white cards (handyman family and domestic pages).
export const WhyUs = ({ title, subtitle, reasons, theme = 'light', id = 'why-us' }) => {
    if (!reasons?.length) return null
    const headingId = `${id}-heading`

    if (theme === 'dark') {
        return (
            <section id={id} className='relative my-4 md:my-6 py-6 md:py-12 bg-linear-to-r from-slate-900 via-slate-800 to-slate-900 overflow-hidden' aria-labelledby={headingId}>
                <div className='relative max-w-6xl mx-auto px-4'>
                    <div className='text-center mb-4 md:mb-5'>
                        <h2 id={headingId} className='text-2xl md:text-3xl font-extrabold text-white tracking-tight'>
                            {title}
                        </h2>
                        {subtitle &&
                            <p className='mt-2 max-w-2xl mx-auto text-gray-300 text-sm leading-relaxed'>{subtitle}</p>
                        }
                    </div>
                    {/* Mobile fold budget: the icon sits inline with the heading, not in
                        its own block above it, which saved ~60px per card on mobile. */}
                    <ul className='grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5'>
                        {reasons.map(({ icon: Icon, title: reasonTitle, desc }) => (
                            <li key={reasonTitle}
                                className='rounded-3xl bg-white/10 backdrop-blur-md border border-white/15 p-3 md:p-6 hover:bg-white/15 transition-colors duration-300'>
                                <h3 className='text-base md:text-lg font-bold text-white mb-1 md:mb-3 flex items-center gap-2 md:gap-3'>
                                    <span className='flex items-center justify-center shrink-0 w-8 h-8 md:w-11 md:h-11 rounded-xl bg-orange-500/20 border border-orange-400/30'>
                                        <Icon className='text-orange-400' aria-hidden='true' />
                                    </span>
                                    {reasonTitle}
                                </h3>
                                <p className='text-sm text-gray-300 leading-relaxed pl-10 md:pl-0'>{desc}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        )
    }

    return (
        <section id={id} className="bg-white py-10 px-4" aria-labelledby={headingId}>
            <div className="max-w-6xl mx-auto">
                <h2 id={headingId} className="text-2xl md:text-3xl font-bold text-center uppercase mb-6">
                    {title}
                </h2>
                {subtitle &&
                    <p className="-mt-3 mb-6 max-w-2xl mx-auto text-center text-sm text-gray-600 leading-relaxed">{subtitle}</p>
                }
                <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {reasons.map(({ icon: Icon, title: reasonTitle, desc }) => (
                        <li key={reasonTitle} className="flex gap-3 items-start bg-white border border-gray-200 rounded-2xl p-4">
                            <Icon className="text-xl text-amber-400 shrink-0 mt-0.5" aria-hidden="true" />
                            <div>
                                <h3 className="text-sm font-bold text-gray-900 mb-1">{reasonTitle}</h3>
                                <p className="text-sm text-gray-600 leading-relaxed">{desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
